import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MessageService } from 'primeng/api';
import * as fromStore from '../../store';
import * as fromFeature from '../../my-features';
import { Store } from '@ngrx/store';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { 
  updateInfoType, 
  GateWayStatus, 
  AuthOtpType,
  AuthOtpDeviceType,
  ReLoadGatewayListSec,
  ReLoadGatewayListCount,
  CheckAuthOtpErrMsg } from '../../shareModel';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import { User } from '../../models/user';
import { GateWayService } from "../../services/gateway.service";
import { DialogComponent } from 'src/app/dialog/dialog.component';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CryptoService} from '../../services/crypto.service';
@Component({
  standalone: false,
  selector: 'app-advanced-setting',
  templateUrl: './advanced-setting.component.html',
  styleUrls: ['./advanced-setting.component.css']
})
export class AdvancedSettingComponent implements OnInit {
  @Input() editProAuth!: boolean;
  @Input() IsSuperAdmin!: boolean;
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  private componentDestroyed = new Subject();
  UpdateInfoParam = {} as UpdateInfoModel;
  GateWayStatus = GateWayStatus;
  advanced_setting_cols: any[] = [
    { field: 'name', header: TRANSLATE('Gateway Name'), width: '200', class: 'col-nowrap', hide: false },
    { field: 'company', header: TRANSLATE('Company'), width: '200', class: 'col-nowrap', hide: false },
    { field: 'status', header: TRANSLATE('Status'), width: '100', class: 'col-nowrap', hide: false },
    { field: 'ipAddress', header: TRANSLATE('IP address'), width: '150', class: 'col-nowrap', hide: false },
    { field: 'connectedDevice', header: TRANSLATE('Connected Device'), width: '150', class: 'col-nowrap', hide: false },
    { field: 'version', header: TRANSLATE('Version'), width: '150', class: 'col-nowrap', hide: false },
    { field: 'automatic', header: TRANSLATE('Automatic'), width: '150', class: 'col-nowrap', hide: false },
  ];
  otpid: number;
  gatewayList = [];
  categoryList = [];
  deviceList = [];
  gatewayDic = [];
  rgionDic = [];
  gatewayDicByRegion = [];
  displayDialog = false;
  displayEditGatewayNameDailog= false;
  gatewayName = '';
  selectedNode: any[] | null = null;
  tabIndex = 0;
  checkGatewayReuslt: boolean;
  ipAddressPattern = /((^|\.)((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]?\d))){4}$/;
  isMsp:boolean = false;
  intervalId: any = null;
  checkDiscoveryExecutingFlag = false;
  ExecId:number = 0;
  params: {
    otp: string;
    RegionIds?: [];
  };
  
  confrimOTPParam = {
    otp: "",
    authId: 0,
    authType: AuthOtpType.SoftwareUpgrade,
    authOtp: '',
  };
  discoveryList = [];
  disableGatewayDic = [];
  connectionDeviceDic = [];
  mspFilter : any;
  UserParam = {} as User;
  advanced_setting_list = [];
  reloadgateway = false;
  automatic = false;
  gatewayname_invalid = false;
  message: string;
  
  displayConfirmDialog: boolean = false;
  displayWarningDialog: boolean = false;
  deleteGatewayItem: any = null;
  dialogInput: {
    Id?: number;
    name?: string;
    UpdateType: string;
    automatic?: boolean;
  };
  displayAdvanSettingDialog: boolean = false;
  gatewayDialogDisabled: boolean = true;
  twoFactorAuthenticationAlertDialog: boolean = false;
  gatewayUpdateDialog: boolean = false;
  gatewayUpdateResultDialog: boolean = false;
  updateResult:number = 0;
  gatewayLoaded: boolean = false;
  clickAutomatic: boolean = false;
  twoFactorAuthentication: boolean = false;
  checkGatewayListFlag: boolean = false;
  intervalCount: number = 0; // 計數器
  checkHeaderCheckbox: boolean = true;
  constructor(private translateService: TranslateService,
    private store: Store<fromStore.State>,
    private messageService: MessageService,
    private router: Router,
    private gateWayService: GateWayService,
    private ngxService: NgxUiLoaderService,
    private cryptoService: CryptoService,) {
    
    this.ngxService.start();

    this.store.dispatch(new fromFeature.GetNotifications());
    this.store.dispatch(new fromFeature.GetPreferences());
    this.store.select(fromStore.getCurrentUser).pipe(takeUntil(this.componentDestroyed)).subscribe(user => {
      if (!this.reloadgateway && user != undefined && !user.isLoading && user.isLoaded && user.isLogin) {
        this.IsSuperAdmin = user.authority === 2;
        this.isMsp = user.isMsp;
        if (!user.isMsp) {
          this.store.dispatch(new fromFeature.ReadGatewayList({ ...this.params }));
          this.store.dispatch(new fromFeature.ReadDiscoveryInfoList({ ...this.params }));
          this.reloadgateway = true;
          this.editProAuth = true;
        }
      }
    })

    this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe(mspFilter => {
      if (mspFilter !== null && mspFilter.filterLoaded && mspFilter.isMsp) {
        this.params = {
          otp: '',
          RegionIds: mspFilter.selectedId,
        };
        this.store.dispatch(new fromFeature.ReadGatewayList({ ...this.params }));
        this.store.dispatch(new fromFeature.ReadDiscoveryInfoList({ ...this.params }));
      }
    })

    this.store
      .select(fromStore.getAuthotp)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {

        if (res.Loaded && !res.Loading) {
          if (res.entities.Flag) {
            if (res.entities.authType === AuthOtpType.SoftwareUpgrade) {
              if (this.childDialog !== undefined && this.childDialog.showUpgradeGatewayVersionDialog !== undefined) {
                this.childDialog.showUpgradeGatewayVersionDialog('SoftwareUpgrade');
              }
              this.otpid = res.entities.Id;
            }
          } else {
            this.childDialog.alertUpgradeGatewayCodeLock();
          }
        } else if (!res.Loaded && res.Loading) {
          if (res.entities !== undefined) {
            this.message = res.entities.Message;
          }
        }
      });


    this.store
      .select(fromStore.getCheckAuthOtp)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res.Loaded && !res.Loading && this.otpid !== undefined && this.confrimOTPParam !== undefined) {
          if (res.entities.Flag) {
            if (res.entities.authType === AuthOtpType.SoftwareUpgrade) {
              // tslint:disable-next-line:max-line-length
              this.messageService.clear();
              if (this.confrimOTPParam.authType === AuthOtpType.SoftwareUpgrade) {
                this.childDialog.dialogType.UpgradeGatewayDialog = false;
                this.gatewayUpdateDialog = true;
              }
            }
          } else {
            this.childDialog.errorMsgUpgradeGatewayCode = CheckAuthOtpErrMsg[res.entities.Message];
            if (res.entities.Message === '1' || res.entities.Message === '2') {
              this.childDialog.UpgradeGatewayOvertime = true;
              if (res.entities.Message === '1') {
                this.childDialog.UpgradeGatewayErrorMsgByLock = true;
              }
            }
              this.childDialog.UpgradeGatewaydialogSaveDirty = true;
          }
          this.ngxService.stop();
        }
      });

    combineLatest( this.store.select(fromStore.getRegions),this.store.select(fromStore.getMspMemberAuthority),this.store.select(fromStore.getMspRegionFilter))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([region, mspAuth, mspFilter]) => {
        if (region !== undefined && region.length > 0 && mspAuth !== undefined && mspAuth.length > 0 && mspFilter !== null && mspFilter.selectedId !== undefined) {
          this.isMsp = mspFilter.isMsp;
          this.mspFilter = mspFilter
          this.rgionDic = [];
          region.map(r => {
            this.rgionDic[r.Id] = r;
          })
        }
      });

    // Get Discovery Info List
    this.store
      .select(fromStore.ReadDiscoveryInfoList)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        this.deviceList = [];
        this.connectionDeviceDic = [];
        if (!res.Loading && res.Loaded) {
          if (res.entities !== undefined && res.entities !== null) {
            const noDisableGateway = [];
            const disableGateway = [];
            this.discoveryList = [];
            if ( Array.isArray(res.entities) && res.entities.length > 0) {
              for (const i in res.entities) {
                const info = res.entities[i];
                if (info !== undefined && info.GatewayList.length > 0) {
                  // 有在運行中的Job,把其中的所有GateWay做成Dic
                  if (info.EnableRun) {
                    info.GatewayList.map(i => {
                      if (noDisableGateway[i] === undefined) {
                        noDisableGateway[i] = i;
                      }
                    })
                  }
                  // 沒在運行中的Job,把其中的所有GateWay做成Dic
                  if (!info.EnableRun) {
                    info.GatewayList.map(i => {
                      if (disableGateway[i] === undefined) {
                        disableGateway[i] = i;
                      }
                    })
                  }
                }
              }
              this.disableGatewayDic = [];
              if (disableGateway.length > 0) {
                // 代表這些gateway所屬的discovery都正在RunningJob
                disableGateway.forEach((d) => {
                  // 排除正在運作中的discovery的gateway
                  // 要做此處理是因為有可能一個DiscoveryJob綁了兩個GateWay但其中一個正在Running另一個沒有
                  // 會做此邏輯是因為DiscoveryList沒有一個欄位可以直接判斷Gateway是否正在被拿來運行中
                  if (!noDisableGateway[d]) {
                    // 重新跑一次dailogGatewayOptions,將被運作中或是offline的Gateway壓成disable
                    this.disableGatewayDic[d] = d;
                  }
                })
              }
              // this.discoveryList = discoveryList.entities;
            }
          }
        }
      });

    // Get Gateway List
    this.store
      .select(fromStore.ReadGateWayList)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((gateway) => {
        if (!gateway.Loading && gateway.Loaded) {
          this.gatewayLoaded = true;
          if (gateway.entities !== undefined && gateway.entities !== null && Array.isArray(gateway.entities) && gateway.entities.length > 0) {
            this.gatewayDic = [];
            this.gatewayList = gateway.entities;
            this.reloadDeviceList();
          } else {
            this.advanced_setting_list = [];
            this.checkHeaderCheckbox = false;
            this.ngxService.stop();
          }
        }
      });

    // Get GateWay Device List
    this.store
      .select(fromStore.ReadGateWayDeviceList)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        this.deviceList = [];
        this.connectionDeviceDic = [];
        if (!res.Loading && res.Loaded) {
          if (res.entities !== undefined && res.entities.length > 0) {
            res.entities.map((c => {
              const item = {
                GatewayId: c.GatewayId,
                GatewayName: c.GatewayName,
                DeviceList: []
              }
              if (c.DeviceList !== undefined && c.DeviceList.length > 0) {
                c.DeviceList.forEach((d) => {
                  const deviceInfo = {
                    dcode: d.dcode,
                    ipAddress: d.IP,
                    SN: d.SN,
                    gatewayId: c.GatewayId,
                    gateName: c.GatewayName,
                    device: d.DeviceName,
                    model: d.Model
                  }
                  item.DeviceList.push(deviceInfo)
                  this.deviceList.push(deviceInfo);
                })
              }
              this.connectionDeviceDic[c.GatewayId] = item;
            }));
          } 
          this.reloadAdvancedSettingList();
          this.checkHeaderCheckbox = this.advanced_setting_list.filter(data => !this.isRowDisabled(data)).length > 0;
        }
      });

    // Update Info
    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.isLoading && res.isLoaded) {
        if (res.type === updateInfoType.DeleteGateway
          || res.type === updateInfoType.UpdateGateway
          || res.type === updateInfoType.UpgradeGateway
        ) {
          this.messageService.clear();
          if (res.isSaved) {
            if (res.type === updateInfoType.UpdateGateway || res.type === updateInfoType.DeleteGateway) {
              this.selectedNode = null;
              this.messageService.add({ severity: 'success', summary: this.translateService.instant(TRANSLATE('success')) });
              // if (res.msg !== undefined && res.msg == '') {
              //   this.messageService.add({ severity: 'success', summary: TRANSLATE('success') });
              // } else {
              //   this.messageService.add({ severity: 'success', summary: TRANSLATE(res.msg) });
              // }
            }
            this.store.dispatch(new fromFeature.ReadGatewayList({ ...this.params }));
          } else {
            // if (res.type === updateInfoType.UpdateGateway || res.type === updateInfoType.UpgradeGateway) {
            //   this.messageService.add({ severity: 'error', summary: TRANSLATE(res.msg) });
            // } else {
            //   this.messageService.add({ severity: 'error', summary: TRANSLATE('Failed') });
            // }
            this.messageService.add({ severity: 'error', summary: this.translateService.instant(TRANSLATE('Failed')) });
          }
          this.displayEditGatewayNameDailog = false;
          this.resetUpdateInfoState();
        }
      }
    });

    this.store.select(fromStore.getPreferences).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.Loaded && !res.Loading) {
        if (res.entities != null && res.entities !== undefined) {
          this.twoFactorAuthentication = Number(res.entities.EnableOTP) === 1 ? true : false;
        }
      }
    });
  }

  ngOnInit() {
    this.initDialogInput();
    // this.ngxService.stop();
  }

  initDialogInput() {
    this.dialogInput = {
      Id: 0,
      UpdateType: 'Edit Gateway',
      name: '',
    };
  }

  showDialog () {
    this.initDialogInput();
    this.displayDialog = true;
  }
  
  showEditDialog(rowData) {
    this.clickAutomatic = false;
    this.displayEditGatewayNameDailog = true;
    this.gatewayDialogDisabled = true;
    this.dialogInput = {
      Id: rowData.Id,
      UpdateType: 'Edit Gateway',
      name: rowData.name,
      automatic: rowData.automatic
    };
  }

  showConfirmDeleteDialog(item) {
    if (item.disable) {
      this.displayWarningDialog = true;
      this.displayConfirmDialog = false;
    } else {
      this.displayConfirmDialog = true;
      this.displayWarningDialog = false;
      this.deleteGatewayItem = item;
    }
  }

  onNameChange(value: string) {
    if (value === this.gatewayName || value == '' || value == undefined) {
      this.gatewayname_invalid = true;
    } else {
      this.gatewayname_invalid = false;;
    }
  }

  reloadAdvancedSettingList() {
    if (this.clickAutomatic) {
      return;
    }
    this.advanced_setting_list = [];
    if (!this.isMsp) {
      this.advanced_setting_cols = this.advanced_setting_cols.filter(col => !(col.field === 'company'));
    }
    [...this.gatewayList].sort(function (a: any, b: any) {
        return b.Id - a.Id;
      }).forEach((g) => {
      this.gatewayDic[g.Id] = g;
      let gatewayDisabled = false;
      // if (g.Status === 1) { // Offline
      //   gatewayDisabled = true;
      // }
      if ((this.disableGatewayDic.length != 0 && this.disableGatewayDic[g.Id] !== undefined) || (g.VersionStatus === 2)) {
        gatewayDisabled = true;
      }
      this.advanced_setting_list.push({
        Id: g.Id,
        name: g.Name,
        regionId: g.RegionId,
        company: this.rgionDic !== undefined && this.rgionDic[g.RegionId] !== undefined ? this.rgionDic[g.RegionId].RegionName : '',
        computer: g.Computer,
        status: g.Status,
        ipAddress: g.IP,
        connectDevice: this.connectionDeviceDic[g.Id] !== undefined && this.connectionDeviceDic[g.Id].DeviceList !== undefined ? this.connectionDeviceDic[g.Id].DeviceList.length : 0,
        version: g.SW,
        versionStatus: g.VersionStatus,
        automatic: g.AutoUpgrade,
        gatewayDisabled: gatewayDisabled,
        hashId: this.cryptoService.aesEncrypt(g.Id),
        updateAvalible: g.VersionStatus === 1 && g.Status === 0 && !gatewayDisabled,
      });

    });
    if (this.gatewayLoaded) {
      this.ngxService.stop();
    }
  }

  EditGatewayNameSave() {
    const param = {
      otp: '',
      Id : this.dialogInput.Id,
      Name : this.dialogInput.name,
      AutoUpgrade : this.dialogInput.automatic,
      Sync : true // Web always true
    }
    this.store.dispatch(new fromFeature.UpdateGateway(param));
  }

  reloadDeviceList() {
    let gatewayListIds = []
    if (this.gatewayList !== undefined && this.gatewayList.length > 0) {
      gatewayListIds = this.gatewayList.filter(s => s.Id).map(s => s.Id);
      const gatewayUpgrading = this.gatewayList.filter(s => s.Status == 0 && s.VersionStatus == 2);
      
      // this.intervalCount++;
      // if (gatewayUpgrading !== undefined && gatewayUpgrading.length > 0 && this.intervalCount < ReLoadGatewayListCount) {  //計數60秒10次,共10分鐘
      if (gatewayUpgrading !== undefined && gatewayUpgrading.length > 0) {
        this.checkGatewayListFlag = true;
        this.startInterval();
      } else {
        this.stopInterval();
        this.checkGatewayListFlag = false;
      }
      const param = {
        otp: '',
        GatewayList: gatewayListIds
      }
      this.store.dispatch(new fromFeature.ReadGatewayDeviceList(param));
    }
  }

  deleteGateway() {
    this.displayConfirmDialog = false;
    if (this.deleteGatewayItem !== undefined && this.deleteGatewayItem !== null) {
      const param = {
        otp: '',
        Id: this.deleteGatewayItem.Id
      }
      this.store.dispatch(new fromFeature.DeleteGateway(param));
    }
  }

  checkAutomaticStatus(event: any) {
    this.clickAutomatic = true;
    this.dialogInput.Id = event.Id;
    this.dialogInput.Id = event.Id;
    this.dialogInput.name = event.name;
    this.dialogInput.automatic = event.automatic;
    this.EditGatewayNameSave();
  }

  upgradeGatewayVersion() {
    this.childDialog.errorMsgUpgradeGatewayCode = "";
    const param = {
      otp: "",
      DeviceType: AuthOtpDeviceType.Web,
      AuthType: AuthOtpType.SoftwareUpgrade,
    };
    this.confrimOTPParam = { ...this.confrimOTPParam, authType: AuthOtpType.SoftwareUpgrade };
    this.store.dispatch(new fromFeature.AddAuthOtp(param));
    this.displayConfirmDialog = false;
  }

  confrimUpgradeGatewayCode(result: string) {
    let type = ''
    let code = ''
    if (result !== '') {
      const paramItem = result.split(',');
      if (paramItem) {
        type = paramItem[0];
        code = paramItem[1];
      }
    }
    if (type === 'SoftwareUpgrade') {
      let authtype = AuthOtpType.SoftwareUpgrade;
      const param = {
        otp: '',
        authId: Number(this.otpid),
        authOtp: code,
        authType: authtype,
      };
      this.store.dispatch(new fromFeature.CheckAuthOtp(param));
    }
  }

  startInterval() {
    if (!this.intervalId) {
      this.intervalId = setInterval(() => {
        if (this.checkGatewayListFlag === true) {
          // console.log("計時器執行次數: " + this.intervalCount);
          this.store.dispatch(new fromFeature.GetNotifications());
          this.store.dispatch(new fromFeature.ReadGatewayList({ ...this.params }));
        }
      }, ReLoadGatewayListSec * 1000); // 每 ReLoadGatewayListSec 秒執行
    }
  }

  stopInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.checkGatewayListFlag = false;
      this.intervalId = null;
      // this.intervalCount = 0; // 確保每次停止時歸零
      // console.log("計時器已停止");
    }
  }

  // 全選時讓特定欄位無法被選取
  isRowDisabled(data: any): boolean {
    return !data.updateAvalible;
  }

  onSelectionChange(selection: any[]) {
    const filtered = selection.filter(data => !this.isRowDisabled(data));
    this.selectedNode = filtered;
  }

  onHeaderCheckboxToggle(event: any) {
    if (event.checked) {
      this.selectedNode = this.advanced_setting_list.filter(data => !this.isRowDisabled(data));
    } else {
      this.selectedNode = [];
    }
  }

  gatewayInputOnChange() {
    this.gatewayDialogDisabled = false;
  }

  saveGatewaySetting() {
    this.displayAdvanSettingDialog = false;
  }

  updateGatewayCheck() {
    if (!this.twoFactorAuthentication) {
      this.twoFactorAuthenticationAlertDialog = true;
    } else {
      this.upgradeGatewayVersion();
    }
  }

  startUpdate() {
    this.intervalCount = 0;
    const gateway_list = this.selectedNode.map(s => s.Id).filter(id => id != null);
    const upgradeParam = {
      otp: '',
      AuthId: Number(this.otpid),
      AuthType: AuthOtpType.SoftwareUpgrade,
      GatewayList: gateway_list
    };
    this.store.dispatch(new fromFeature.UpgradeGateway(upgradeParam));
    this.gatewayUpdateDialog = false;
    this.selectedNode = null;
    // this.showUpdateResult();
  }

  showUpdateResult() {
    this.gatewayUpdateResultDialog = true;
    this.updateResult = 0;
  }

  backClicked() {
    this.router.navigate(['/gateway-setting']);
  }

  ngOnDestroy(): void {
    this.stopInterval();
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}
